<template>
  <div class="px-3 py-4" v-if="itemOrderDetail">
  <!--
    <div
      @click="handleSupport"
      v-if="itemOrderDetail.status == 3"
      class="d-flex justify-content-end align-items-center gap-1 position-relative z-3 mb-3"
    >
      <p class="mb-0 font-size-12">{{ $t("esim_help") }}</p>
      <van-icon name="question" size="18" />
    </div>
  -->
    <div class="bg-white rounded-3 p-4" v-if="itemOrderDetail">
      <div class="d-flex justify-content-between align-items-start py-2 detail-header">
        <div class="detail-header-left">
          <p
            class="mb-1 font-size-12 text-muted text-uppercase"
            style="letter-spacing: 0.4px;"
          >
            {{ $t("esim_full_name") }}
          </p>
          <p
            class="mb-0 text-uppercase font-size-16 fw-bold"
            style="letter-spacing: 0.5px;"
          >
            {{ itemOrderDetail.fullName }}
          </p>
        </div>
        <div class="detail-header-right d-flex flex-column align-items-end text-end">
          <p class="mb-1 font-size-12 text-muted detail-order-code-label">
            {{ $t("esim_order_code") }}: {{ itemOrderDetail.orderCode }}
          </p>
          <p class="mb-0 font-size-12" :style="transactionTypeStyle">
            {{ transactionTypeLabel }}
          </p>
        </div>
      </div>
      <van-divider
        dashed
        :style="{
          border: ' none',
          backgroundImage:
            'repeating-linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) 7px, transparent 7px, transparent 14px)',
        }"
      ></van-divider>
      <div class="mb-3">
        <van-cell-group class="list-order-detail">
          <van-cell  >
            <template #title>{{ $t("esim_id_number") }}</template>
            <template #value>{{ itemOrderDetail.idNo }}</template>
          </van-cell>
          <van-cell v-if="itemOrderDetail.dob ">
            <template #title>{{ $t("esim_dob") }}</template>
            <template #value>{{ itemOrderDetail.dob }}</template>
          </van-cell>
          <van-cell>
            <template #title>{{ $t("esim_phone_number") }}</template>
            <template #value>{{ itemOrderDetail.phone }}</template>
          </van-cell>
          <van-cell>
            <template #title>{{ $t("esim_amount") }}</template>
            <template #value>
              <span class="fw-bold" style="color: #00ba00">
                ${{ formatNumber(itemOrderDetail.amount) }}
              </span>
            </template>
          </van-cell>
          <van-cell
            v-if="itemOrderDetail.status != 4 && itemOrderDetail.packageName"
          >
            <template #title>{{ $t("esim_package") }}</template>
            <template #value>{{ itemOrderDetail.packageName }}</template>
          </van-cell>
          <van-cell>
            <template #title>{{ $t("esim_ordered_date") }}</template>
            <template #value>{{
              formatDateToHHMMSpaceDDMMYYYY(itemOrderDetail.orderDate)
            }}</template>
          </van-cell>
          <van-cell>
            <template #title>{{ $t("esim_status") }}</template>
            <template #value>
              <span v-if="itemOrderDetail.status == 1" style="color: #C41627">
                {{ $t("esim_status_fail") }}
              </span>
              <span v-if="itemOrderDetail.status == 2" style="color: #3E7BFA">
                {{ $t("esim_status_waiting") }}
              </span>
              <span v-if="itemOrderDetail.status == 3" style="color: #44CA83">
                {{ $t("esim_status_success") }}
              </span>
              <span v-if="itemOrderDetail.status == 4" style="color: #FF0000">
                {{ $t("esim_status_expired") }}
              </span>
            </template>
          </van-cell>
          <van-cell
            v-if="itemOrderDetail.status == 3 && itemOrderDetail.status != 1"
          >
            <template #title>{{ $t("esim_payment_date") }}</template>
            <template #value>{{
              formatDateToHHMMSpaceDDMMYYYY(itemOrderDetail.paymentDate)
            }}</template>
          </van-cell>
          <van-cell v-if="itemOrderDetail.status == 3">
            <template #title>{{ $t("esim_transaction_id") }}</template>
            <template #value>{{ itemOrderDetail.paymentReference ||  itemOrderDetail.tranId }}</template>
          </van-cell>
          <van-cell
            v-if="itemOrderDetail.status == 4 || itemOrderDetail.status == 2"
          >
            <template #title>{{ $t("esim_expired_time") }}</template>
            <template #value>{{
              formatDateToHHMMSpaceDDMMYYYY(itemOrderDetail.expiredTime)
            }}</template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="mb-3" v-if="itemOrderDetail.status == 2">
        <van-button
          @click="handleContinuePayment"
          class="btn btn-primary rounded-3 shadown-primary text-uppercase shadow-1"
          block
          >{{ $t("esim_continue") }}</van-button
        >
      </div>
      <div
        class="mb-3"
        v-if="itemOrderDetail.qrCode && itemOrderDetail.status == 3"
      >
        <p class="font-size-14 text-center">{{ $t("esim_serial_number") }}: {{ itemOrderDetail.serial }}</p>
        <div class="d-flex justify-content-center mb-3">
          <div class="image-base64">
            <van-image width="200" height="200" :src="qrImageSrc" />
          </div>
        </div>
        <!--HOai 
        <div class="d-flex justify-content-center gap-3">
          <div @click="downloadQRCode">
            <img width="32" height="32" src="@/static/arrow-down-solid.svg" />
          </div>
          <div @click="shareQRCode">
            <img width="32" height="32" src="@/static/share-nodes-solid.svg" />
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>
<script>
import { Divider, Cell, CellGroup, Image } from "vant";
import { mapState } from "vuex";
import { formatDateToHHMMDDMMYYYY } from "@/ultis/dateFormat";
import {
  formatToDateDDMMYYYY,
  formatDateToHHMMSpaceDDMMYYYY,
} from "@/ultis/dateFormat";
import { formatNumber } from "@/ultis/numberFormat";
import { CONSTANTS } from "@/helpers/constants";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { encrypt, sign, keyToPem } from "anhdev99.rsa";

export default {
  name: "Detail",
  components: {
    [Divider.name]: Divider,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
  },

  data() {
    return {
      base64Image: "",
    };
  },
  created() {
    if (!this.itemOrderDetail) return;
    console.log("itemOrderDetail", this.itemOrderDetail);
  },
  computed: {
    ...mapState("esimBuyStore", ["itemOrderDetail"]),
    ...mapState("headerStore", ["title"]),
    qrImageSrc() {
      const prefix = "data:image/png;base64,";
      return this.itemOrderDetail.qrCode?.startsWith(prefix)
        ? this.itemOrderDetail.qrCode
        : prefix + this.itemOrderDetail.qrCode;
    },
    transactionTypeValue() {
      return (this.itemOrderDetail?.transactionType || "").toLowerCase();
    },
    transactionTypeLabel() {
      console.log("transactionTypeValue", this.transactionTypeValue); 
      if (this.transactionTypeValue === "BUY_ESIM" || this.transactionTypeValue === "buy_esim") {
        return this.$t("esim_transaction_buy_esim");
      }
      if (this.transactionTypeValue === "CHANGE_ESIM" || this.transactionTypeValue === "change_esim") {
        return this.$t("esim_transaction_change_esim");
      }
      return this.itemOrderDetail?.transactionType || "";
    },
    transactionTypeStyle() {
      const base = {
        textTransform: "uppercase",
        padding: "2.5px 7px",
        borderRadius: "100px",
        fontSize: "8px",
        fontWeight: 700,
      };
      if (this.transactionTypeValue === "BUY_ESIM" || this.transactionTypeValue === "buy_esim") {
        return { ...base, backgroundColor: "#FEF2F2", color: "#CC1E26" };
      }
      if (this.transactionTypeValue === "CHANGE_ESIM" || this.transactionTypeValue === "change_esim") {
        return { ...base, backgroundColor: "#EFF6FF", color: "#1D4ED8" };
      }
      return base;
    },
  },
  mounted() {
    this.changeTitle(this.$t(this.title));
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_order_details");
      },
      immediate: true,
    },
  },
  methods: {
    formatDateToHHMMDDMMYYYY,
    formatNumber,
    formatDateToHHMMSpaceDDMMYYYY,
    color_primary() {
      return CONSTANTS.color_primary;
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    downloadQRCode() {
      if (this.qrImageSrc) {
        this.base64Image = this.qrImageSrc;
      } else {
        return;
      }
      const pureBase64 = this.base64Image.replace(
        /^data:image\/\w+;base64,/,
        "",
      );
      this.$bridge.callHandler(
        "download",
        {
          content: pureBase64,
          type: "base64",
          fileName: "qr-code.png",
          trxId: "",
        },
        (response) => {
          if (response?.success) {
            alert("The image has been successfully saved to the gallery!");
          } else {
            alert("Failed to save the image!");
          }
        },
      );
    },
    shareQRCode() {
      if (this.qrImageSrc) {
        this.base64Image = this.qrImageSrc;
      } else {
        return;
      }
      const pureBase64 = this.base64Image.replace(
        /^data:image\/\w+;base64,/,
        "",
      );
      this.$bridge.callHandler("share", {
        fileName: "qr-code.png",
        content: pureBase64,
        type: "image/png",
        message: "",
        trxId: "",
      });
    },
    async handleContinuePayment() {
      console.log("itemOrderDetail", this.itemOrderDetail);
      this.$store.dispatch("loadingStore/showLoading", true);
      if (this.itemOrderDetail) {
        const ttRaw = this.itemOrderDetail.transactionType || "";
        const tt = ttRaw.toLowerCase().replace(/\s+/g, " ").trim();
        const ttUpper = ttRaw.toUpperCase();
        const isChangeEsim =
          tt === "change esim" ||
          ttUpper === "CHANGE_ESIM" ||
          ttUpper === "CHANGE_TO_ESIM";
        this.$store.dispatch("esimBuyStore/detailPaymentInfo", {
          orderCode: this.itemOrderDetail.orderCode || "",
          fullName: this.itemOrderDetail.fullName || "",
          gender: this.itemOrderDetail.gender || "",
          dob: this.itemOrderDetail.dob || "",
          province: this.itemOrderDetail.province || "",
          idNumber: this.itemOrderDetail.idNo || "",
          phoneNumber: this.itemOrderDetail.phone || "",
          phoneNumberPrice: isChangeEsim ? 0  : this.itemOrderDetail.isdnPrice || this.itemOrderDetail.amount || 0,
          packageCode: this.itemOrderDetail.packageCode || "",
          packagePrice: this.itemOrderDetail.packagePrice || "",
          packageName: this.itemOrderDetail.packageName || "",
          totalPrice: this.itemOrderDetail.amount || "",
          transIdeKYC: this.itemOrderDetail.tranIdEkyc || "",
          idType: this.itemOrderDetail.idType || "",
          fee: isChangeEsim ? 0 : this.itemOrderDetail.fee || 0,
          totalAmount: this.itemOrderDetail.amount || 0,
          isEkyc: this.isEkyc,
          requestId: this.itemOrderDetail.requestId || "",
          hashPayment: this.itemOrderDetail.hashPayment || "",
          flowType: isChangeEsim
            ? ESIM_ORDER_FLOW.CHANGE
            : ESIM_ORDER_FLOW.BUY,
        });
        this.$router.replace({ path: "/esim-payment" });
      }
      this.$store.dispatch("loadingStore/showLoading", false);
    },
    handleSupport() {
      this.$router.push("/support");
    },
  },
};
</script>
<style>
/* Custom Van Cell Group */
.list-order-detail.van-hairline--top-bottom {
  position: unset !important;
}

.list-order-detail .van-cell__title {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.7) !important;
}

.list-order-detail .van-cell {
  padding: 4px 0px !important;
}

.list-order-detail .van-cell .van-cell__value {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 500;
}

.list-order-detail .van-cell::after {
  border-bottom: none !important;
}

.detail-header {
  gap: 16px;
}

.detail-header-right {
  min-width: 160px;
}

.detail-order-code-label {
  text-transform: uppercase;
  opacity: 0.72;
  letter-spacing: 0.3px;
}
</style>
